// removed by extract-text-webpack-plugin
module.exports = {"cookieDisclaimer":"_2pMurAl","container":"_1cJDHsE","summary":"_2EMw4Zz","readMore":"_2afHWeu","closeButton":"_1EF2tpx"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Header/CookieDisclaimer/index.css
// module id = ./template/components/Header/CookieDisclaimer/index.css
// module chunks = client.sitechrome